/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * CyrenCare API
 * CyrenCare NestJS REST API for healthcare survey platform
 * OpenAPI spec version: 2.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CreateSurveyMetaDto,
  SurveyMetaControllerFindBySurveyParams,
  SurveyMetaResponseDto,
  UpdateSurveyMetaDto
} from '.././types'
import { customInstance } from '../../custom-instance';
import type { ErrorType } from '../../custom-instance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Find survey meta by surveyId and metaKey
 */
export const surveyMetaControllerFindBySurvey = (
    params: SurveyMetaControllerFindBySurveyParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SurveyMetaResponseDto>(
      {url: `/survey-meta`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSurveyMetaControllerFindBySurveyQueryKey = (params: SurveyMetaControllerFindBySurveyParams,) => {
    return [`/survey-meta`, ...(params ? [params]: [])] as const;
    }

    
export const getSurveyMetaControllerFindBySurveyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof surveyMetaControllerFindBySurvey>>>, TError = ErrorType<unknown>>(params: SurveyMetaControllerFindBySurveyParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof surveyMetaControllerFindBySurvey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSurveyMetaControllerFindBySurveyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof surveyMetaControllerFindBySurvey>>> = ({ signal }) => surveyMetaControllerFindBySurvey(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof surveyMetaControllerFindBySurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type SurveyMetaControllerFindBySurveyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof surveyMetaControllerFindBySurvey>>>
export type SurveyMetaControllerFindBySurveyInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Find survey meta by surveyId and metaKey
 */
export const useSurveyMetaControllerFindBySurveyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof surveyMetaControllerFindBySurvey>>>, TError = ErrorType<unknown>>(
 params: SurveyMetaControllerFindBySurveyParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof surveyMetaControllerFindBySurvey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSurveyMetaControllerFindBySurveyInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSurveyMetaControllerFindBySurveyQueryOptions = <TData = Awaited<ReturnType<typeof surveyMetaControllerFindBySurvey>>, TError = ErrorType<unknown>>(params: SurveyMetaControllerFindBySurveyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveyMetaControllerFindBySurvey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSurveyMetaControllerFindBySurveyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof surveyMetaControllerFindBySurvey>>> = ({ signal }) => surveyMetaControllerFindBySurvey(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof surveyMetaControllerFindBySurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type SurveyMetaControllerFindBySurveyQueryResult = NonNullable<Awaited<ReturnType<typeof surveyMetaControllerFindBySurvey>>>
export type SurveyMetaControllerFindBySurveyQueryError = ErrorType<unknown>

/**
 * @summary Find survey meta by surveyId and metaKey
 */
export const useSurveyMetaControllerFindBySurvey = <TData = Awaited<ReturnType<typeof surveyMetaControllerFindBySurvey>>, TError = ErrorType<unknown>>(
 params: SurveyMetaControllerFindBySurveyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveyMetaControllerFindBySurvey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSurveyMetaControllerFindBySurveyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create survey meta
 */
export const surveyMetaControllerCreate = (
    createSurveyMetaDto: CreateSurveyMetaDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SurveyMetaResponseDto>(
      {url: `/survey-meta`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSurveyMetaDto
    },
      options);
    }
  


export const getSurveyMetaControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof surveyMetaControllerCreate>>, TError,{data: CreateSurveyMetaDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof surveyMetaControllerCreate>>, TError,{data: CreateSurveyMetaDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof surveyMetaControllerCreate>>, {data: CreateSurveyMetaDto}> = (props) => {
          const {data} = props ?? {};

          return  surveyMetaControllerCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SurveyMetaControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof surveyMetaControllerCreate>>>
    export type SurveyMetaControllerCreateMutationBody = CreateSurveyMetaDto
    export type SurveyMetaControllerCreateMutationError = ErrorType<unknown>

    /**
 * @summary Create survey meta
 */
export const useSurveyMetaControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof surveyMetaControllerCreate>>, TError,{data: CreateSurveyMetaDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof surveyMetaControllerCreate>>,
        TError,
        {data: CreateSurveyMetaDto},
        TContext
      > => {

      const mutationOptions = getSurveyMetaControllerCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Update survey meta
 */
export const surveyMetaControllerUpdate = (
    id: number,
    updateSurveyMetaDto: UpdateSurveyMetaDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SurveyMetaResponseDto>(
      {url: `/survey-meta/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSurveyMetaDto
    },
      options);
    }
  


export const getSurveyMetaControllerUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof surveyMetaControllerUpdate>>, TError,{id: number;data: UpdateSurveyMetaDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof surveyMetaControllerUpdate>>, TError,{id: number;data: UpdateSurveyMetaDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof surveyMetaControllerUpdate>>, {id: number;data: UpdateSurveyMetaDto}> = (props) => {
          const {id,data} = props ?? {};

          return  surveyMetaControllerUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SurveyMetaControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof surveyMetaControllerUpdate>>>
    export type SurveyMetaControllerUpdateMutationBody = UpdateSurveyMetaDto
    export type SurveyMetaControllerUpdateMutationError = ErrorType<unknown>

    /**
 * @summary Update survey meta
 */
export const useSurveyMetaControllerUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof surveyMetaControllerUpdate>>, TError,{id: number;data: UpdateSurveyMetaDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof surveyMetaControllerUpdate>>,
        TError,
        {id: number;data: UpdateSurveyMetaDto},
        TContext
      > => {

      const mutationOptions = getSurveyMetaControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    